import $ from 'jquery';
import { cookie } from "cookie_js";
import './bxslider.min.js';
import './jquery.sidr.js';
import GMaps from 'gmaps';
//import Router from './Router.js';

jQuery(function($){
    if(cookie.get('accept') > 0 ) {
        $('.notice-cookie').hide();
        $('body').removeClass('cookie-not-accept');
    }

    $('#use-cookies').on('click', function(e){
        e.preventDefault();
        cookie.set('accept', '1', {expires: 52,});
        $('body').removeClass('cookie-not-accept');
        $('.notice-cookie').hide();
     });


    $('#nav-toggle').sidr({
        name: 'sidr',
        side: 'right',
        source: '#main-nav'
    });

    $('.bxslider').bxSlider({
        nextText: '<i class="icon-right-open"></i>',
        prevText: '<i class="icon-left-open"></i>'
    });

    $('.content table').wrap('<div class="responsive-table"></div>');


    // let router = new Router();
    // router.route('page-template-page-calculation', () => {
    //     let view = new CalculatorView();
    //     view.render();
    // });
    // router.route('page-id-60', () => {
    //     var map = new GMaps({
    //       div: '#map-route',
    //       zoom: 11,
    //       scrollwheel: false,
    //       draggable: false,
    //       streetViewControl: false,
    //       lat: 50.827845,
    //       lng: 12.921369700000014,
    //       zoomControlOptions: {
    //         style: google.maps.ZoomControlStyle.SMALL
    //       },
    //     });
    //
    //     var marker = map.addMarker({
    //       lat: 50.82501,
    //       lng: 12.848600000000033,
    //       infoWindow: {
    //           content: '<p style="font-size: 12px;">WCW Chemnitz, Harthweg 150</p>'
    //       }
    //     });
    //
    //     var marker2 = map.addMarker({
    //       lat: 50.814217,
    //       lng: 12.892771400000015,
    //       infoWindow: {
    //           content: '<p style="font-size: 12px;">WCW Chemnitz Filiale Kappel Harthweg 150</p>'
    //       }
    //     });
    //
    //     infoWindow.open(map, marker);
    // });

    // router.route('page-id-64', () => {
    //     var map, infoWindow;
    //     infoWindow = new google.maps.InfoWindow({});
    //         map = new GMaps({
    //         div: '#map-areas',
    //         zoom: 12,
    //         streetViewControl: false,
    //         lat: 50.827845,
    //         lng: 12.921369700000014
    //     });
    //     map.loadFromKML({
    //         url: 'http://wcw.212.224.95.166.xip.io/wp-content/themes/wcw/chemnitz.kml',
    //         suppressInfoWindows: true,
    //         events: {
    //             click: function(point){
    //                 location.href = '/wohnungssuche/stadtteile/' + point.featureData.name.toLowerCase()
    //                 .replace(/\s+/g,'-')
    //                 .replace(/ß/gu,'ss')
    //                 .replace(/ö/gu,'oe');
    //             }
    //         }
    //     });
    // });
    //
    // router.resolve();
});



// WEBPACK FOOTER //
// ./js/theme.js